var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3818 3.21011C11.2581 2.50747 12.7282 2.50613 13.6162 3.21988L13.6172 3.22086L20.5469 8.76089C20.8456 9.00196 21.1178 9.40159 21.2959 9.86832C21.4742 10.3356 21.538 10.8173 21.4756 11.1994L20.1465 19.1564C19.9471 20.3267 18.7848 21.3095 17.5996 21.3097H6.39941C5.27824 21.3097 4.19552 20.4541 3.90039 19.3752L3.85254 19.1564L2.52246 11.1974L2.52148 11.1945C2.45555 10.8142 2.51753 10.3343 2.69531 9.86832C2.87303 9.4025 3.14708 9.00295 3.4502 8.76187L3.45215 8.75992L10.3818 3.21011ZM11.999 10.0002C10.343 10.0003 8.99902 11.3441 8.99902 13.0002C8.9991 14.6561 10.3431 16 11.999 16.0002C13.6551 16.0002 14.9989 14.6562 14.999 13.0002C14.999 11.344 13.6552 10.0002 11.999 10.0002Z",
    fill: "#0747A6",
    stroke: "#0747A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeFilled);
export default __webpack_public_path__ + "static/media/homeFilled.62e623292230bd60884248663c501144.svg";
export { ForwardRef as ReactComponent };